import React from 'react';

import {Group} from '@pb/kit-component-group';
import {Icon, Icons} from '@pb/kit-component-icon';

export const NoContentView = () => (
    <Group alignItems="center" justify="center" style={{flexGrow: 1}}>
        <Group gap="s">
            <Icon type={Icons.INFO}/>
            <b>Select a notification from the list of topics to see its content</b>
        </Group>
    </Group>
);
